import { Clock } from "lucide-react";

export const fmtTs = (s) => {
    if (!s) return "";
    const d = new Date(s);
    return isNaN(d) ? s : d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true });
};

const titleCase = (s) => (s || "").toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// Vertical timestamped timeline. items: [{ label|status|event, at, by, note }]
export function Timeline({ items, accent = "#009C95", testid = "timeline", title = "Timeline" }) {
    const rows = (items || []).filter((t) => t && t.at);
    if (!rows.length) return null;
    return (
        <div data-testid={testid}>
            <h3 className="mb-2 flex items-center gap-1.5 font-heading text-sm font-bold text-navy"><Clock size={15} style={{ color: accent }} /> {title}</h3>
            <ol className="relative ml-1.5 border-l-2 border-navy/10">
                {rows.map((t, i) => (
                    <li key={`${t.at}-${i}`} className="mb-3 ml-4 last:mb-0" data-testid={`${testid}-item-${i}`}>
                        <span className="absolute -left-[7px] mt-1 h-3 w-3 rounded-full border-2 border-white" style={{ backgroundColor: i === rows.length - 1 ? accent : "#CBD5E1" }} />
                        <p className="text-sm font-semibold text-navy">{t.label || titleCase(t.status || t.event)}</p>
                        <p className="text-[11px] text-navy/50">{fmtTs(t.at)}{t.by ? ` · ${t.by}` : ""}</p>
                        {t.note && <p className="mt-0.5 text-xs text-navy/60">{t.note}</p>}
                    </li>
                ))}
            </ol>
        </div>
    );
}
